import styled from 'styled-components';

export const StyledOnboardingImage = styled.svg`
  margin-bottom: 32px;
`;

export const StyledOnboardingImageContainer = styled.div`
  text-align: center;
`;
